import router from '@scoutgg/ftw/source/services/router.service'

router.route('edit-player', '/player-sources?season={season}&team={team}&search={formalName}')
router.route('apis', '/external-apis/view/:api?/:sport?/:tab?/:id?')
router.route('dasboard', '/dashboard/:match_id?')
